// extracted by mini-css-extract-plugin
export default {"container":"editProfile_container__bOcv0","header":"editProfile_header__m21Sr","backBtn":"editProfile_backBtn__r9RCY","footer":"editProfile_footer__cpKJS"};